import Head from 'next/head';
import React, { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { Breadcrumb } from 'src/common/types/api/v4/boats/search';
import ProductAggregateRatingSchema from 'src/common/components/MetaTags/ProductAggregateRatingSchema';
import BreadcrumbListSchema from '../../../common/components/MetaTags/BreadcrumbSchemaList';
import DescriptionMetaTag from '../../../common/components/MetaTags/DescriptionMetaTag';
import OpenGraphMetaTags from '../../../common/components/MetaTags/OpenGraphMetaTags';
import { SearchResults } from '../../../common/types/api/v4/boats/search';
import type { SeoData } from '../../../common/types/api/v4/rutter/v1/search/seo';

export type MetaFieldsProps = {
  searchResults: SearchResults;
  seo: SeoData;
  noIndex: boolean;
  breadcrumbs: Breadcrumb[];
};

const MetaFields: FC<MetaFieldsProps> = ({
  seo,
  searchResults,
  noIndex,
  breadcrumbs,
}) => {
  const [t] = useTranslation('search-page');
  const { query } = useRouter();
  const rawPage = Array.isArray(query.page) ? query.page[0] : query.page;
  const parsedPage = rawPage ? parseInt(rawPage as string, 10) : NaN;
  const pageNumberForTitle = Number.isInteger(parsedPage) && parsedPage > 0 ? ` | ${t('page')} ${parsedPage}` : '';
  const title = (seo?.copy?.title ?? t('title')) + pageNumberForTitle;
  const description = seo?.copy?.description ?? t('meta-description');
  const sampleReviews = searchResults.top_reviews ? searchResults?.top_reviews?.slice(0, 2) : [];
  const imageUrl = searchResults.results.length ? searchResults.results?.[0]?.photo_url : null;

  return (
    <>
      <Head>
        <title>
          {title}
        </title>
      </Head>
      <DescriptionMetaTag content={description} />
      <OpenGraphMetaTags
        canonicalPath={searchResults.canonical_url}
        title={title}
        description={description}
        imageUrl={imageUrl}
        noIndex={noIndex}
      />
      <ProductAggregateRatingSchema sampleReviews={sampleReviews} />
      <BreadcrumbListSchema breadcrumbs={breadcrumbs} />
    </>
  );
};

export default MetaFields;
